// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d17dacf1","239":"98c5589e","455":"25b2cab7"}[chunkId] + ".chunk.js";
};